import {
  GET_PROCESSORS,
  ADD_PROCESSOR,
  ADD_PROCESSOR_ERROR,
  UPDATE_PROCESSOR,
  UPDATE_PROCESSOR_ERROR,
  DELETE_PROCESSOR,
  GET_ACTIVE_PROCESSORS,
  GET_ACTIVE_PROCESSORS_ERROR,
  RESET_STORE,
  MANUALLY_TRIGGER_MESSAGE
} from "../types";

const initialState = {
  processors: [],
  processorsActive: []
};

export const processorsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROCESSORS:
      return { ...state, processors: action.payload };
    case GET_ACTIVE_PROCESSORS:
      return { ...state, processorsActive: action.payload };
    case GET_ACTIVE_PROCESSORS_ERROR:
      return { ...state, processorsActiveError: action.payload };
    case ADD_PROCESSOR:
      return { ...state, addProcessor: action.payload };
    case ADD_PROCESSOR_ERROR:
      return { ...state, addProcessorError: action.payload };
    case UPDATE_PROCESSOR:
      return { ...state, addProcessor: action.payload };
    case UPDATE_PROCESSOR_ERROR:
      return { ...state, addProcessorError: action.payload };
    case DELETE_PROCESSOR:
      let NewNotifications = state.processors.filter(
        (processor: any) => processor._id !== action.payload
      );
      return {
        ...state,
        processors: NewNotifications,
        loading: false
      };
    case MANUALLY_TRIGGER_MESSAGE:
      return { ...state, addProcessorError: action.payload };
    case RESET_STORE:
      return { ...state, addProcessor: "" };
    default:
      return state;
  }
};
